export default {
  'general_permissions.finance.change_finance_info': {
    relatedTo: 'general_permissions.finance.view_finance_info',
    on: true,
    action: true,
  },
  'general_permissions.finance.view_finance_info': {
    relatedTo: 'general_permissions.finance.change_finance_info',
    on: false,
    action: false,
  },
};
